import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Collapse,
  Chip,
  Button,
  DialogActions,
  ButtonGroup,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Colors } from "@template/style";
import CheckboxLabel from "components/atoms/CheckboxLabel";
import SelectLabel from "components/atoms/SelectLabel";
import DateRangePicker from "components/atoms/DatePickerCustom/DateRangePicker";
import {
  getAllReportItem,
  getFuelAll,
  getListMaster,
  getListReportType,
} from "@api/itemReport";
import { apiGetAprrovalList } from "@api/flowApproval";
import {
  LIST_FUEL,
  LIST_WORK_STATUS_TLOG,
  screenIdSupport,
  TEMPLATE_EDIT_TYPE,
  IMAGE_EXIST_TYPE,
} from "@shared-constants";
import {
  getListContainerApi,
  getListContainerDefectApi,
} from "@api/itemReport";
import LoadingOverlayController from "@shared-components/loading/LoadingOverlayController";
import formatDateToString from "@utils/DateFormat";
import { Validation } from "@validation";
import { getMemberListApi } from "@api/member";
import { useSelector } from "react-redux";
import { getProjectLocationIdStore } from "selector/projectSelector";
import SelectDialog from "./SelectDialog";
import { cloneDeep } from "lodash";
import ModalSearchUserByLocation from "components/molecules/ModalSearchUserByLocation";
import { issueType } from "@utils/template/riskyId";
import { getListProject } from "@api/project";
import LabelRequired from "components/atoms/LabelRequired";
import DatePickerCustom from "components/atoms/DatePickerCustom";
import { getListUserByLocationId } from "@api/User";
import { getListTemplate } from "@api/template";
import SearchDialogDetail from "./SearchDialogDetail";
import { IExcelTemplateSearchForm } from "./SearchDialogDetail/ExcelTemplateDetail";

interface IProps {
  open: boolean;
  data?: IWorkSearchForm;
  screenId: string;
  onGetTemplateInfo: Function;
  onClose: Function;
  onSearch: Function;
}

interface Imultiple {
  id: string;
  name: string;
}

interface IworkStatus {
  id: string;
  name: string;
  isSelected: boolean;
}

export interface IWorkSearchForm {
  report_type: string;
  report_type_name: string;
  project_id: string;
  project_id_name: string;
  applied_at_s: string;
  applied_at_e: string;
  approved_at_s: string;
  approved_at_e: string;
  updated_at_s: string;
  updated_at_e: string;
  work_status: Array<IworkStatus>;
  approver: Array<Imultiple>;
  author: Array<Imultiple>;
  template_id: string;
  approval_flow: string;
  approval_flow_name: string;
  next_user: string;
  image_exist: string;
  // 庫内商品事故報告書項目
  place_found_issue: string;
  incident_date_s: string;
  incident_date_e: string;
  issue_place_floor: Array<Imultiple>;
  issue_place_span: Array<Imultiple>;
  is_product_issue: boolean;
  is_packaging_issue: boolean;
  responsible_person: string;
  person_found_issue: string;
  product_type: string;
  product_name: string;
  amount_of_product: string;
  product_id: string;
  product_packaging_status: string;
  reason_cause_issue: string;
  warehouse_place_floor: Array<Imultiple>;
  warehouse_place_span: Array<Imultiple>;
  bad_place: string;
  // 日次フォークリフト点検簿
  vehicles_frame_no: string;
  vehicles_workplace: string;
  vehicles_model: string;
  vehicles_fuel_type: string;
  vehicles_name: string;
  driver: string;
  year_month: string;
  check_user: string;
  memo: string;
  //InspectionReport
  date_of_delivery_s: string;
  date_of_delivery_e: string;
  container_no: string;
  container_size: string;
  delivery_time: string;
  carrier_name: string;
  unit_class: string;
  delivery_location: string;
  invoice_no: string;
  seal_no: string;
  berth_number: string;
  sealed: boolean | undefined;
  product_class: string;
  model_name: string;
  defective_products: Array<Imultiple>;
  person_worker: string;
  container_status: Array<Imultiple>;
  // ユーザー作成帳票
  attached_file_exist: string;
  excel_template: IExcelTemplateSearchForm;
}

let LIST_WORK_STATUS = [...LIST_WORK_STATUS_TLOG];
LIST_WORK_STATUS[0].isSelected = false;

export const initialStateForm: IWorkSearchForm = {
  report_type: "",
  report_type_name: "",
  project_id: "",
  project_id_name: "",
  applied_at_s: "",
  applied_at_e: "",
  approved_at_s: "",
  approved_at_e: "",
  updated_at_s: "",
  updated_at_e: "",
  work_status: cloneDeep(LIST_WORK_STATUS),
  approver: [],
  author: [],
  template_id: "",
  approval_flow: "",
  approval_flow_name: "",
  next_user: "",
  image_exist: IMAGE_EXIST_TYPE.not_designation, // 写真添付有無 初期値: 指定なし
  place_found_issue: "",
  incident_date_s: "",
  incident_date_e: "",
  issue_place_floor: [],
  issue_place_span: [],
  is_product_issue: false,
  is_packaging_issue: false,
  responsible_person: "",
  person_found_issue: "",
  product_type: "",
  product_name: "",
  amount_of_product: "",
  product_id: "",
  product_packaging_status: "",
  reason_cause_issue: "",
  warehouse_place_floor: [],
  warehouse_place_span: [],
  bad_place: "",
  vehicles_frame_no: "",
  vehicles_workplace: "",
  vehicles_model: "",
  vehicles_fuel_type: "",
  vehicles_name: "",
  driver: "",
  year_month: "",
  check_user: "",
  memo: "",
  date_of_delivery_s: "",
  date_of_delivery_e: "",
  container_no: "",
  container_size: "",
  delivery_time: "",
  carrier_name: "",
  unit_class: "",
  delivery_location: "",
  invoice_no: "",
  seal_no: "",
  berth_number: "",
  sealed: undefined,
  product_class: "",
  model_name: "",
  defective_products: [],
  person_worker: "",
  container_status: [],
  attached_file_exist: IMAGE_EXIST_TYPE.not_designation, // ファイル添付有無 初期値: 指定なし
  excel_template: {},
};

const SearchDialog: React.FC<IProps> = ({
  open,
  data,
  screenId,
  onGetTemplateInfo = () => {},
  onClose = () => {},
  onSearch = () => {},
}: IProps) => {
  const [fetchData, setFetchData] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [listReportType, setListReportType] = useState<any[]>([]);
  const [listAllProject, setListAllProject] = useState<any[]>([]);
  const [listProject, setListProject] = useState<any[]>([]);
  const [listTemplate, setListTemplate] = useState<any[]>([]);
  const [approvalFlowList, setApprovalFlowList] = useState<Type.FlowInfo[]>([]);
  const [allFlowList, setAllFlowList] = useState<{
    [key: string]: Type.FlowInfo[];
  }>({});
  const [listOccurrenceLocation, setListOccurrenceLocation] = useState<any[]>(
    [],
  );
  const [listContainerStatus, setContainerStatus] = useState<any[]>([]);
  const [defectList, setDefectList] = useState<any[]>([]);
  const [listSpanMaster, setListSpanMaster] = useState<any[]>([]);
  const [listWorkplace, setListWorkplace] = useState<any[]>([]);
  const [listFuel, setListFuel] = useState<any[]>([]);
  const [listUser, setListUser] = useState<any[]>([]);
  const [openSelectDialog, setOpenSelectDialog] = useState(false);
  const [selectDialogField, setSelectDialogField] =
    useState<keyof IWorkSearchForm>();
  const [selectDialiogData, setSelectDialiogData] = useState<any[]>([]);
  const [currentData, setCurrentData] = useState<any>([]);
  const [nameAttribute, setNameAttribute] = useState<string>("");
  const [openMemberSearch, setOpenMemberSearch] = useState(false);
  const [stateForm, setStateForm] = useState<IWorkSearchForm>(
    cloneDeep(initialStateForm),
  );
  const [formError, setFormError] = useState<IWorkSearchForm>(
    cloneDeep(initialStateForm),
  );
  const location_id = useSelector(getProjectLocationIdStore);
  const ListDetailTitle = {
    [TEMPLATE_EDIT_TYPE.TEMPLATE_EXCEL_REPORT]: "ユーザー作成帳票",
  };

  useEffect(() => {
    if (open) {
      if (!fetchData) {
        getListData();
        setFetchData(true);
      }
    }
  }, [open, data, fetchData]);

  useEffect(() => {
    if (open) {
      setStateForm(data ?? cloneDeep(initialStateForm));
    }
  }, [open, data]);

  const getListData = useCallback(async () => {
    try {
      LoadingOverlayController.show();
      // 帳票種類
      const res_report = await getListReportType();
      if (res_report?.data) {
        setListReportType(res_report.data);
      }

      // 帳票
      const res_project = await getListProjectData();
      if (res_project && res_project.length > 0) {
        setListAllProject(res_project);
      }

      // アカウント
      // const res_users = await getMemberListApi();
      // setListUser(res_users?.users.data);
      const res_users = await getListUserByLocationId();
      if (res_users && res_users.length > 0) {
        setListUser(res_users);
      }

      // テンプレート
      const res_template = await getListTemplate({
        template_type: "TEMPLATE_WORK",
      });
      if (res_template.data && res_template.data.length > 0) {
        setListTemplate(res_template.data);
      }
    } finally {
      LoadingOverlayController.hide();
    }
  }, [location_id]);

  const getListProjectData = async (
    lastKeyword?: string,
    sort_by?: string,
    data?: any,
  ) => {
    const params = {
      keyword: "",
      sort_type: "update_time_latest_sort",
      last_key: lastKeyword ?? "",
      sort_by: sort_by,
      not_ignore_user_made: true,
    };

    const res = await getListProject(params);
    let list_project = res?.data;
    if (data) {
      list_project = [...data, ...res?.data];
    }
    if (res?.last_key) {
      list_project = await getListProjectData(
        res?.last_key?.SK,
        res?.last_key?.sort_by,
        list_project,
      );
    }

    return list_project;
  };

  const getFlowList = useCallback(
    async (template_id: string) => {
      if (template_id) {
        if (Object.keys(allFlowList).find((v) => v == template_id)) {
          setApprovalFlowList(allFlowList[template_id]);
        } else {
          try {
            LoadingOverlayController.show();
            let flow_type = "";
            const approvalFlows = await apiGetAprrovalList({
              template_id,
              flow_type,
            });
            if (approvalFlows.length > 0) {
              setApprovalFlowList(approvalFlows);
              setAllFlowList({ ...allFlowList, [template_id]: approvalFlows });
            } else {
              setApprovalFlowList([]);
              setAllFlowList({ ...allFlowList, [template_id]: [] });
            }
          } finally {
            LoadingOverlayController.hide();
          }
        }
      }
    },
    [allFlowList],
  );

  useEffect(() => {
    getMasterByScreenId();
  }, [screenId]);

  const getMasterByScreenId = async () => {
    switch (screenIdSupport[screenId]) {
      case TEMPLATE_EDIT_TYPE.RISKY_REPORT:
        if (listOccurrenceLocation.length == 0) await getRiskyReportMaster();
        break;
      case TEMPLATE_EDIT_TYPE.TEMPLATE_FORKLIFT_REPORT:
        if (listFuel.length == 0) await getTemplateForkliftMaster();
        break;
      case TEMPLATE_EDIT_TYPE.INSPECTION_REPORT:
        if (listContainerStatus.length == 0) await getInspectionReportMaster();
        break;
    }
  };

  const getRiskyReportMaster = async () => {
    try {
      LoadingOverlayController.show();
      // フロア、スパン
      const res_report_item = await getAllReportItem(location_id, {
        master: JSON.stringify(["occurrenceLocation", "spanMaster"]),
      });
      setListOccurrenceLocation(res_report_item["occurrenceLocation"]);
      setListSpanMaster(res_report_item["spanMaster"]);
    } finally {
      LoadingOverlayController.hide();
    }
  };

  const getTemplateForkliftMaster = async () => {
    try {
      LoadingOverlayController.show();
      // 燃料
      await getFuelAll().then((res) => {
        if (res?.data) {
          setListFuel(res.data.length > 0 ? res.data : LIST_FUEL);
        }
      });

      // 使用場所
      await getListMaster("workplace", location_id).then((res) => {
        if (res?.data) {
          setListWorkplace(res.data);
        }
      });
    } finally {
      LoadingOverlayController.hide();
    }
  };

  const getInspectionReportMaster = async () => {
    try {
      LoadingOverlayController.show();
      //コンテナの状態:InspectionReport
      const res_container = await getListContainerApi();
      if (res_container?.data) {
        setContainerStatus(res_container?.data);
      }
      //不適合内容:InspectionReport
      const res_defect = await getListContainerDefectApi();
      if (res_defect?.data) {
        setDefectList(res_defect?.data);
      }
    } finally {
      LoadingOverlayController.hide();
    }
  };

  const StackChip = (props: { children?: React.ReactNode }) => {
    return (
      <Stack direction={"row"} sx={{ gap: 1, flexWrap: "wrap" }} spacing={0}>
        {props.children}
      </Stack>
    );
  };

  const renderMenuItem = useCallback(
    (
      list: Array<any>,
      name?: string,
      getName: (item: any) => string = () => "",
      addEmpty: boolean = true,
      value: string = "SK",
      key: string = "SK",
    ) => {
      if (addEmpty) {
        list = [{}, ...list];
      }
      return list.map((item: any, index: number) =>
        index == 0 && addEmpty ? (
          <MenuItem value={""} key={index}>
            <em>未選択</em>
          </MenuItem>
        ) : (
          <MenuItem
            value={item[value]}
            key={item[key]}
            className="IgnoreExtractRuleTarget"
          >
            {name ? item[name] : getName(item)}
          </MenuItem>
        ),
      );
    },
    [],
  );

  const renderMultiSelect = useCallback(
    (field: keyof IWorkSearchForm) => {
      if (typeof stateForm[field] !== "object") return null;
      return (stateForm[field] as Array<Imultiple>).map((item, index) => (
        <Chip
          onDelete={() => {
            let cloneData = [...(stateForm[field] as Array<Imultiple>)];
            cloneData.splice(index, 1);
            setStateForm({ ...stateForm, [field]: cloneData });
          }}
          label={item.name}
          key={item.id}
        />
      ));
    },
    [stateForm],
  );

  const onChangeText =
    (field: keyof IWorkSearchForm) =>
    (newText: string | boolean | undefined) => {
      let newStateForm = { ...stateForm, [field]: newText };
      setStateForm(newStateForm);
    };

  const onChangeBoolean = (field: keyof IWorkSearchForm, value: boolean) => {
    let newStateForm = { ...stateForm };
    if (stateForm[field] === value) {
      //同じボタンを続けて押した場合は、値を外す
      newStateForm = { ...stateForm, [field]: undefined };
    } else {
      newStateForm = { ...stateForm, [field]: value };
    }
    setStateForm(newStateForm);
  };

  const onChangeSelect =
    (field: string) =>
    (
      list: any[],
      value: string,
      name?: string,
      key: string = "SK",
      getName: (item: any) => string = () => "",
    ) => {
      const field_name = field + "_name";
      const selected = list.find((item) => item && item[key] === value);
      var value_name = "";
      if (selected) {
        value_name = name ? selected[name] : getName(selected);
      }
      setStateForm({
        ...stateForm,
        [field]: value,
        [field_name]: value_name,
      });
    };

  const onChangeDate = (
    newValue: string | null,
    field: keyof IWorkSearchForm,
  ) => {
    let displayValue = "";
    if (!newValue) {
      newValue = "";
    } else {
      // YMDだと二桁の日が直接入力不可だが、バリデーションには使う
      newValue = formatDateToString(newValue, "YMD");
      displayValue = formatDateToString(newValue, "YMd");
    }

    let mess = "";
    let newStateForm = { ...stateForm, [field]: displayValue };
    if (newValue) {
      mess = validator(field, newValue);
    }
    setFormError({ ...formError, [field]: mess });

    if (mess.length === 0) {
      if (field == "applied_at_s") {
        // 日付範囲を月初・月末に整形
        const field_e: keyof IWorkSearchForm = field.replace("_s", "_e") as any;
        var start_dt = getDateRange(newValue, field);
        var end_dt = getDateRange(newValue, field_e);
        newStateForm = {
          ...newStateForm,
          [field]: formatDateToString(start_dt, "YMd"),
          [field_e]: formatDateToString(end_dt, "YMd"),
        };
      } else {
        // 日付範囲のチェック
        const field_s: keyof IWorkSearchForm = field.replace("_e", "_s") as any;
        const field_e: keyof IWorkSearchForm = field.replace("_s", "_e") as any;
        const start = field.includes("_s") ? newValue : stateForm[field_s];
        const end = field.includes("_e") ? newValue : stateForm[field_e];
        let mess_start = "";
        let mess_end = "";

        if (typeof start == "string" && typeof end == "string") {
          if (start && end) {
            mess_start = Validation.validateDateRange(
              new Date(start),
              new Date(end),
            );
            if (mess_start) {
              mess_end = mess_start;
              // isError = true;
            }
          }
          setFormError((prev) => {
            return {
              ...prev,
              [field_s]: mess_start,
              [field_e]: mess_end,
            };
          });
        }
      }
    }

    setStateForm(newStateForm);
  };

  const onChangeDateYm =
    (field: keyof IWorkSearchForm) => (value: string | null) => {
      if (!value) {
        value = "";
      } else {
        value = formatDateToString(value, "YM");
      }

      let mess = "";
      if (value) {
        mess = validator(field, value);
      }
      setFormError({ ...formError, [field]: mess });
      setStateForm((prev) => ({ ...prev, [field]: value }));
    };

  const onChangeWorkStatus = useCallback(
    (index: number, isSelected: boolean) => {
      let cloneData = cloneDeep(stateForm.work_status);
      cloneData[index].isSelected = isSelected;
      setStateForm({ ...stateForm, work_status: cloneData });
    },
    [stateForm],
  );

  const validator = (field: keyof IWorkSearchForm, value: string) => {
    let mess: string = "";

    switch (field) {
      case "applied_at_s":
        mess = Validation.validateDate(value, "申請月", false);
        break;
      case "applied_at_e":
        mess = Validation.validateDate(value, "申請月", false);
        break;
      case "approved_at_s":
        mess = Validation.validateDate(value, "最終承認日開始", false);
        break;
      case "approved_at_e":
        mess = Validation.validateDate(value, "最終承認日終了", false);
        break;
      case "updated_at_s":
        mess = Validation.validateDate(value, "最終更新日開始", false);
        break;
      case "updated_at_e":
        mess = Validation.validateDate(value, "最終更新日終了", false);
        break;
      case "incident_date_s":
        mess = Validation.validateDate(value, "発生年月日開始", false);
        break;
      case "incident_date_e":
        mess = Validation.validateDate(value, "発生年月日終了", false);
        break;
      case "date_of_delivery_s":
        mess = Validation.validateDate(value, "搬入年月日開始", false);
        break;
      case "date_of_delivery_e":
        mess = Validation.validateDate(value, "搬入年月日終了", false);
        break;
      case "year_month":
        mess = Validation.validateDate(value, "実施年月", false);
        break;
    }
    return mess;
  };

  const ITEM_BUTTON_SELECT: { [key: string]: string } = {
    approver: "full_name",
    author: "full_name",
    issue_place_floor: "occurrence_location_name",
    warehouse_place_floor: "occurrence_location_name",
    issue_place_span: "span_name",
    warehouse_place_span: "span_name",
    container_status: "container_status_name",
    defective_products: "container_defect_detail_name",
  };

  const handleClickSelect = (field: keyof IWorkSearchForm, list: any[]) => {
    if (typeof stateForm[field] == "object") {
      setCurrentData(stateForm[field]);
      setSelectDialiogData(list);
      setNameAttribute(ITEM_BUTTON_SELECT[field]);
      setSelectDialogField(field);
      setOpenSelectDialog(true);
    }
  };

  const handleChoose = (data: Array<Imultiple>) => {
    if (selectDialogField) {
      setStateForm({ ...stateForm, [selectDialogField]: data });
    }
  };

  const disabledSubmit = useMemo(() => {
    return (
      // initStateとformErrorの初期値が同値であり、initStateで
      // image_existを指定なしで初期値に設定しているため
      // someの判定回避を目的として!(d in IMAGE_EXIST_TYPE)を追加。
      Object.values(formError).some(
        (d) => typeof d == "string" && d.length > 0 && !(d in IMAGE_EXIST_TYPE),
      ) ||
      stateForm.report_type == "" ||
      stateForm.project_id == "" ||
      stateForm.applied_at_s == "" ||
      stateForm.applied_at_e == ""
    );
  }, [stateForm, formError]);

  const getDateRange = (date: string, key: string) => {
    const arrValue = date.split("-");
    var dt = null;
    dt = new Date(Number(arrValue[0]), Number(arrValue[1]) - 1, 1);
    if (key == "applied_at_e") {
      dt = new Date(dt);
      dt.setMonth(dt.getMonth() + 1);
      dt.setDate(0);
    }

    return dt;
  };

  const handleClear = () => {
    let newStateForm = cloneDeep(initialStateForm);
    newStateForm = {
      ...newStateForm,
      ["applied_at_s"]: stateForm.applied_at_s,
      ["applied_at_e"]: stateForm.applied_at_e,
    };

    let newFormError = cloneDeep(initialStateForm);
    newFormError = {
      ...newFormError,
      ["applied_at_s"]: formError.applied_at_s,
    };
    setStateForm(newStateForm);
    setFormError(newFormError);
    setListProject([]);
    setApprovalFlowList([]);
  };

  const templateInfo = useMemo(() => {
    const selected_project = listProject.find(
      (item) => item.PK == stateForm.project_id,
    );
    return listTemplate.find(
      (template) => template.SK === selected_project?.template_project_id,
    );
  }, [listProject, listTemplate, stateForm.project_id]);

  const getScreenId = (templateProjectId: string) => {
    let response = "";
    const templateInfo = listTemplate.find(
      (template) => template.SK === templateProjectId,
    );
    if (templateInfo) {
      response = templateInfo.screen_id;
    }
    return response;
  };

  return (
    <Dialog
      maxWidth="md"
      sx={{ "& .MuiDialog-paper": { width: "80%" } }}
      open={open}
      onClose={() => onClose()}
    >
      <ModalSearchUserByLocation
        open={openMemberSearch}
        onClose={() => {
          setSelectDialogField(undefined);
          setOpenMemberSearch(false);
        }}
        onChoose={(users) => {
          const selected = users.map((user) => ({
            id: user.PK,
            name: user.full_name,
          }));
          handleChoose(selected);
        }}
      />
      <SelectDialog
        open={openSelectDialog}
        data={selectDialiogData}
        selectedData={currentData}
        nameAttribute={nameAttribute}
        onClose={() => {
          setSelectDialogField(undefined);
          setOpenSelectDialog(false);
        }}
        onChoose={handleChoose}
      />

      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="body1">帳票検索条件</Typography>
        {/* <IconButton
          onClick={() => onClose()}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton> */}
      </DialogTitle>

      <DialogContent dividers>
        <Stack>
          <SelectLabel
            label={<LabelRequired title="帳票種類" />}
            value={stateForm.report_type}
            onChange={(e) => {
              onChangeSelect("report_type")(
                listReportType,
                e.target.value,
                undefined,
                undefined,
                (item) => item.report_type_code + ":" + item.report_type_name,
              );
              setListProject(
                listAllProject.filter(
                  (item) => item.report_type_id == e.target.value,
                ),
              );
            }}
          >
            {renderMenuItem(
              listReportType,
              undefined,
              (item) => item.report_type_code + ":" + item.report_type_name,
            )}
          </SelectLabel>
          <SelectLabel
            label={<LabelRequired title="帳票" />}
            value={stateForm.project_id}
            onChange={async (e) => {
              onChangeSelect("project_id")(
                listProject,
                e.target.value,
                "project_name",
                "PK",
              );
              const selected_project = listProject.find(
                (item) => item.PK == e.target.value,
              );
              await getFlowList(selected_project?.template_project_id);
              onGetTemplateInfo(
                getScreenId(selected_project?.template_project_id),
                selected_project?.template_project_id,
              );
            }}
          >
            {renderMenuItem(
              listProject,
              undefined,
              (item) =>
                "【" +
                item.report_number +
                ":" +
                item.report_name +
                "】" +
                item.project_name,
              true,
              "PK",
              "PK",
            )}
          </SelectLabel>
          <Box flexDirection={{ xs: "column", md: "row" }} display={"flex"}>
            <DatePickerCustom
              label={<LabelRequired title="申請月" />}
              value={stateForm.applied_at_s ? stateForm.applied_at_s : null}
              onChange={(v) => {
                onChangeDate(v, "applied_at_s");
              }}
              onBlur={() => {
                // 直接入力時
                let newStateForm = {
                  ...stateForm,
                  ["applied_at_s"]: formatDateToString(
                    stateForm.applied_at_s,
                    "YMD",
                  ),
                  ["applied_at_e"]: formatDateToString(
                    stateForm.applied_at_e,
                    "YMD",
                  ),
                };
                setStateForm(newStateForm);
              }}
              onAccept={(v) => {
                // カレンダー選択時
                var day = formatDateToString(v, "YMD");
                var start_dt = getDateRange(day, "applied_at_s");
                var end_dt = getDateRange(day, "applied_at_e");
                let newStateForm = {
                  ...stateForm,
                  ["applied_at_s"]: formatDateToString(start_dt, "YMD"),
                  ["applied_at_e"]: formatDateToString(end_dt, "YMD"),
                };
                setStateForm(newStateForm);
              }}
              openTo="year"
              views={["year", "month"]}
              inputFormat="yyyy/MM"
              mask="____/__"
              helperText={formError.applied_at_s}
              error={formError.applied_at_s.length > 0}
            />
          </Box>
          <DateRangePicker
            label="最終承認日"
            value={[stateForm.approved_at_s, stateForm.approved_at_e]}
            onChange={[
              (v) => {
                onChangeDate(v, "approved_at_s");
              },
              (v) => {
                onChangeDate(v, "approved_at_e");
              },
            ]}
            onBlur={[
              () => {
                onChangeText("approved_at_s")(
                  formatDateToString(stateForm.approved_at_s, "YMD"),
                );
              },
              () => {
                onChangeText("approved_at_e")(
                  formatDateToString(stateForm.approved_at_e, "YMD"),
                );
              },
            ]}
            onAccept={[
              (v) => {
                onChangeText("approved_at_s")(formatDateToString(v, "YMD"));
              },
              (v) => {
                onChangeText("approved_at_e")(formatDateToString(v, "YMD"));
              },
            ]}
            helperText={[formError.approved_at_s, formError.approved_at_e]}
            error={[
              formError.approved_at_s.length > 0,
              formError.approved_at_e.length > 0,
            ]}
          />
          <DateRangePicker
            label="最終更新日"
            value={[stateForm.updated_at_s, stateForm.updated_at_e]}
            onChange={[
              (v) => {
                onChangeDate(v, "updated_at_s");
              },
              (v) => {
                onChangeDate(v, "updated_at_e");
              },
            ]}
            onBlur={[
              () => {
                onChangeText("updated_at_s")(
                  formatDateToString(stateForm.updated_at_s, "YMD"),
                );
              },
              () => {
                onChangeText("updated_at_e")(
                  formatDateToString(stateForm.updated_at_e, "YMD"),
                );
              },
            ]}
            onAccept={[
              (v) => {
                onChangeText("updated_at_s")(formatDateToString(v, "YMD"));
              },
              (v) => {
                onChangeText("updated_at_e")(formatDateToString(v, "YMD"));
              },
            ]}
            helperText={[formError.updated_at_s, formError.updated_at_e]}
            error={[
              formError.updated_at_s.length > 0,
              formError.updated_at_e.length > 0,
            ]}
          />
          <FormControl>
            <InputLabel>帳票状況</InputLabel>
            <Stack
              direction={{ xs: "column", md: "row" }}
              sx={{ gap: 1 }}
              spacing={0}
            >
              {stateForm.work_status.map((item, index) => {
                return (
                  <CheckboxLabel
                    label={item?.name}
                    checked={item?.isSelected}
                    onChange={(_, checked) => {
                      onChangeWorkStatus(index, checked);
                    }}
                    key={item?.id}
                  />
                );
              })}
            </Stack>
          </FormControl>
          <FormControl>
            <InputLabel>承認者</InputLabel>
            <StackChip>
              {renderMultiSelect("approver")}
              <Button
                size="small"
                onClick={() => {
                  setOpenMemberSearch(true);
                  setSelectDialogField("approver");
                }}
              >
                追加
              </Button>
            </StackChip>
          </FormControl>
          <FormControl>
            <InputLabel>申請者</InputLabel>
            <StackChip>
              {renderMultiSelect("author")}
              <Button
                size="small"
                onClick={() => {
                  setOpenMemberSearch(true);
                  setSelectDialogField("author");
                }}
              >
                追加
              </Button>
            </StackChip>
          </FormControl>
          <TextField
            label="帳票番号"
            value={stateForm.template_id}
            onChange={(e) => {
              onChangeText("template_id")(e.target.value);
            }}
          />
          <SelectLabel
            label="承認フロー"
            value={stateForm.approval_flow}
            onChange={(e) => {
              onChangeSelect("approval_flow")(
                approvalFlowList,
                e.target.value,
                "flow_name",
              );
            }}
          >
            {renderMenuItem(approvalFlowList, "flow_name")}
          </SelectLabel>
          <SelectLabel
            label="ネクストプロセス"
            value={stateForm.next_user}
            onChange={(e) => {
              onChangeSelect("next_user")(
                listUser,
                e.target.value,
                "full_name",
              );
            }}
          >
            {renderMenuItem(listUser, "full_name")}
          </SelectLabel>
          <FormControl>
            <InputLabel>写真添付有無</InputLabel>
            <RadioGroup
              name="search-type-radio-group"
              value={stateForm.image_exist}
              row
              onChange={(_, value) => {
                setStateForm({
                  ...stateForm,
                  image_exist: value,
                });
              }}
            >
              <FormControlLabel
                value={IMAGE_EXIST_TYPE.not_designation}
                label="指定なし"
                control={<Radio />}
              />
              <FormControlLabel
                value={IMAGE_EXIST_TYPE.not_attached}
                label="写真添付なし"
                control={<Radio />}
              />
              <FormControlLabel
                value={IMAGE_EXIST_TYPE.attached}
                label="写真添付あり"
                control={<Radio />}
              />
            </RadioGroup>
          </FormControl>
          {screenIdSupport[screenId] ==
            TEMPLATE_EDIT_TYPE.TEMPLATE_EXCEL_REPORT && (
            <FormControl>
              <InputLabel>ファイル添付有無</InputLabel>
              <RadioGroup
                name="search-type-radio-group"
                value={stateForm.attached_file_exist}
                row
                onChange={(_, value) => {
                  setStateForm({
                    ...stateForm,
                    attached_file_exist: value,
                  });
                }}
              >
                <FormControlLabel
                  value={IMAGE_EXIST_TYPE.not_designation}
                  label="指定なし"
                  control={<Radio />}
                />
                <FormControlLabel
                  value={IMAGE_EXIST_TYPE.not_attached}
                  label="ファイル添付なし"
                  control={<Radio />}
                />
                <FormControlLabel
                  value={IMAGE_EXIST_TYPE.attached}
                  label="ファイル添付あり"
                  control={<Radio />}
                />
              </RadioGroup>
            </FormControl>
          )}
          {/* テンプレートごとの詳細検索 要修正*/}
          {ListDetailTitle[screenIdSupport[screenId]] && (
            <div>
              <Box sx={styles.dialogHeader}>
                <Typography color={"white"}>
                  {ListDetailTitle[screenIdSupport[screenId]]}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <IconButton
                  onClick={() => {
                    setOpenReport(!openReport);
                  }}
                  sx={{ color: "white" }}
                >
                  {openReport ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              <Collapse in={openReport} timeout="auto" unmountOnExit>
                <SearchDialogDetail
                  screenId={screenId}
                  stateForm={stateForm}
                  templateInfo={templateInfo}
                  setStateForm={setStateForm}
                  setFormError={setFormError}
                />
              </Collapse>
            </div>
          )}
          {screenIdSupport[screenId] == TEMPLATE_EDIT_TYPE.RISKY_REPORT ? (
            <div>
              <Box sx={styles.dialogHeader}>
                <Typography color={"white"}>庫内商品事故報告書項目</Typography>
                <Box sx={{ flexGrow: 1 }} />
                <IconButton
                  onClick={() => {
                    setOpenReport(!openReport);
                  }}
                  sx={{ color: "white" }}
                >
                  {openReport ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              <Collapse in={openReport} timeout="auto" unmountOnExit>
                <Stack>
                  <TextField
                    label="発行元"
                    value={stateForm.place_found_issue}
                    onChange={(e) => {
                      onChangeText("place_found_issue")(e.target.value);
                    }}
                  />
                  <DateRangePicker
                    label="発生年月日"
                    value={[
                      stateForm.incident_date_s,
                      stateForm.incident_date_e,
                    ]}
                    onChange={[
                      (v) => {
                        onChangeDate(v, "incident_date_s");
                      },
                      (v) => {
                        onChangeDate(v, "incident_date_e");
                      },
                    ]}
                    onBlur={[
                      () => {
                        onChangeText("incident_date_s")(
                          formatDateToString(stateForm.incident_date_s, "YMD"),
                        );
                      },
                      () => {
                        onChangeText("incident_date_e")(
                          formatDateToString(stateForm.incident_date_e, "YMD"),
                        );
                      },
                    ]}
                    onAccept={[
                      (v) => {
                        onChangeText("incident_date_s")(
                          formatDateToString(v, "YMD"),
                        );
                      },
                      (v) => {
                        onChangeText("incident_date_e")(
                          formatDateToString(v, "YMD"),
                        );
                      },
                    ]}
                    helperText={[
                      formError.incident_date_s,
                      formError.incident_date_e,
                    ]}
                    error={[
                      formError.incident_date_s.length > 0,
                      formError.incident_date_e.length > 0,
                    ]}
                  />
                  <FormControl>
                    <InputLabel>発生場所フロア</InputLabel>
                    <StackChip>
                      {renderMultiSelect("issue_place_floor")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect(
                            "issue_place_floor",
                            listOccurrenceLocation,
                          )
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>
                  <FormControl>
                    <InputLabel>発生場所スパン</InputLabel>
                    <StackChip>
                      {renderMultiSelect("issue_place_span")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect("issue_place_span", listSpanMaster)
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>
                  <FormControl>
                    <InputLabel>事故区分</InputLabel>
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      sx={{ gap: 1 }}
                      spacing={0}
                    >
                      <CheckboxLabel
                        label={issueType.product}
                        checked={stateForm.is_product_issue}
                        onChange={(_, checked) => {
                          onChangeText("is_product_issue")(checked);
                        }}
                      />
                      <CheckboxLabel
                        label={issueType.packaging}
                        checked={stateForm.is_packaging_issue}
                        onChange={(_, checked) => {
                          onChangeText("is_packaging_issue")(checked);
                        }}
                      />
                    </Stack>
                  </FormControl>
                  <TextField
                    label="事故当事者"
                    value={stateForm.responsible_person}
                    onChange={(e) => {
                      onChangeText("responsible_person")(e.target.value);
                    }}
                  />
                  <TextField
                    label="発見者氏名"
                    value={stateForm.person_found_issue}
                    onChange={(e) => {
                      onChangeText("person_found_issue")(e.target.value);
                    }}
                  />
                  <TextField
                    label="分類"
                    value={stateForm.product_type}
                    onChange={(e) => {
                      onChangeText("product_type")(e.target.value);
                    }}
                  />
                  <TextField
                    label="商品名"
                    value={stateForm.product_name}
                    onChange={(e) => {
                      onChangeText("product_name")(e.target.value);
                    }}
                  />
                  <TextField
                    label="数量"
                    sx={{ width: 120 }}
                    value={stateForm.amount_of_product}
                    onChange={(e) => {
                      onChangeText("amount_of_product")(e.target.value);
                    }}
                  />
                  <TextField
                    label="機番"
                    value={stateForm.product_id}
                    onChange={(e) => {
                      onChangeText("product_id")(e.target.value);
                    }}
                  />
                  <TextField
                    label="荷姿状態"
                    value={stateForm.product_packaging_status}
                    onChange={(e) => {
                      onChangeText("product_packaging_status")(e.target.value);
                    }}
                  />
                  <TextField
                    label="事故発生理由"
                    value={stateForm.reason_cause_issue}
                    onChange={(e) => {
                      onChangeText("reason_cause_issue")(e.target.value);
                    }}
                  />
                  <FormControl>
                    <InputLabel>格納場所フロア</InputLabel>
                    <StackChip>
                      {renderMultiSelect("warehouse_place_floor")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect(
                            "warehouse_place_floor",
                            listOccurrenceLocation,
                          )
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>
                  <FormControl>
                    <InputLabel>格納場所スパン</InputLabel>
                    <StackChip>
                      {renderMultiSelect("warehouse_place_span")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect(
                            "warehouse_place_span",
                            listSpanMaster,
                          )
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>
                  <TextField
                    label="不良ロケ"
                    value={stateForm.bad_place}
                    onChange={(e) => {
                      onChangeText("bad_place")(e.target.value);
                    }}
                  />
                </Stack>
              </Collapse>
            </div>
          ) : screenIdSupport[screenId] ==
            TEMPLATE_EDIT_TYPE.TEMPLATE_FORKLIFT_REPORT ? (
            <div>
              <Box sx={styles.dialogHeader}>
                <Typography color={"white"}>
                  日次フォークリフト点検簿
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <IconButton
                  onClick={() => {
                    setOpenReport(!openReport);
                  }}
                  sx={{ color: "white" }}
                >
                  {openReport ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              <Collapse in={openReport} timeout="auto" unmountOnExit>
                <Stack>
                  <TextField
                    label="車体番号"
                    value={stateForm.vehicles_frame_no}
                    onChange={(e) => {
                      onChangeText("vehicles_frame_no")(e.target.value);
                    }}
                  />
                  <SelectLabel
                    label="事業場名"
                    value={stateForm.vehicles_workplace}
                    onChange={(e) => {
                      onChangeText("vehicles_workplace")(e.target.value);
                    }}
                  >
                    {renderMenuItem(
                      listWorkplace,
                      "workplace_name",
                      undefined,
                      true,
                      "workplace_name",
                    )}
                  </SelectLabel>
                  <TextField
                    label="車種"
                    value={stateForm.vehicles_model}
                    onChange={(e) => {
                      onChangeText("vehicles_model")(e.target.value);
                    }}
                  />
                  <SelectLabel
                    label="燃料"
                    value={stateForm.vehicles_fuel_type}
                    onChange={(e) => {
                      onChangeText("vehicles_fuel_type")(e.target.value);
                    }}
                  >
                    {renderMenuItem(
                      listFuel,
                      "fuel_name",
                      undefined,
                      true,
                      "fuel_name",
                    )}
                  </SelectLabel>
                  <TextField
                    label="車両番号"
                    value={stateForm.vehicles_name}
                    onChange={(e) => {
                      onChangeText("vehicles_name")(e.target.value);
                    }}
                  />
                  <TextField
                    label="担当者名"
                    value={stateForm.driver}
                    onChange={(e) => {
                      onChangeText("driver")(e.target.value);
                    }}
                  />
                  <DatePickerCustom
                    label="実施年月"
                    value={stateForm.year_month}
                    onChange={onChangeDateYm("year_month")}
                    openTo="year"
                    views={["year", "month"]}
                    inputFormat="yyyy/MM"
                    mask="____/__"
                    helperText={formError.year_month}
                    error={formError.year_month.length > 0}
                  />
                  <TextField
                    label="点検実施者名"
                    value={stateForm.check_user}
                    onChange={(e) => {
                      onChangeText("check_user")(e.target.value);
                    }}
                  />
                  <TextField
                    label="備考"
                    value={stateForm.memo}
                    onChange={(e) => {
                      onChangeText("memo")(e.target.value);
                    }}
                  />
                </Stack>
              </Collapse>
            </div>
          ) : screenIdSupport[screenId] ==
            TEMPLATE_EDIT_TYPE.INSPECTION_REPORT ? (
            <div>
              <Box sx={styles.dialogHeader}>
                <Typography color={"white"}>InspectionReport</Typography>
                <Box sx={{ flexGrow: 1 }} />
                <IconButton
                  onClick={() => {
                    setOpenReport(!openReport);
                  }}
                  sx={{ color: "white" }}
                >
                  {openReport ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              <Collapse in={openReport} timeout="auto" unmountOnExit>
                <Stack>
                  <DateRangePicker
                    label="搬入年月日"
                    value={[
                      stateForm.date_of_delivery_s,
                      stateForm.date_of_delivery_e,
                    ]}
                    onChange={[
                      (v) => {
                        onChangeDate(v, "date_of_delivery_s");
                      },
                      (v) => {
                        onChangeDate(v, "date_of_delivery_e");
                      },
                    ]}
                    onBlur={[
                      () => {
                        onChangeText("date_of_delivery_s")(
                          formatDateToString(
                            stateForm.date_of_delivery_s,
                            "YMD",
                          ),
                        );
                      },
                      () => {
                        onChangeText("date_of_delivery_e")(
                          formatDateToString(
                            stateForm.date_of_delivery_e,
                            "YMD",
                          ),
                        );
                      },
                    ]}
                    onAccept={[
                      (v) => {
                        onChangeText("date_of_delivery_s")(
                          formatDateToString(v, "YMD"),
                        );
                      },
                      (v) => {
                        onChangeText("date_of_delivery_e")(
                          formatDateToString(v, "YMD"),
                        );
                      },
                    ]}
                    helperText={[
                      formError.date_of_delivery_s,
                      formError.date_of_delivery_e,
                    ]}
                    error={[
                      formError.date_of_delivery_s.length > 0,
                      formError.date_of_delivery_e.length > 0,
                    ]}
                  />
                  <TextField
                    label="コンテナ番号"
                    value={stateForm.container_no}
                    onChange={(e) => {
                      onChangeText("container_no")(e.target.value);
                    }}
                  />
                  <TextField
                    label="コンテナサイズ"
                    value={stateForm.container_size}
                    onChange={(e) => {
                      onChangeText("container_size")(e.target.value);
                    }}
                  />
                  <TextField
                    label="納入時間"
                    value={stateForm.delivery_time}
                    onChange={(e) => {
                      onChangeText("delivery_time")(e.target.value);
                    }}
                  />
                  <TextField
                    label="搬入者名"
                    value={stateForm.carrier_name}
                    onChange={(e) => {
                      onChangeText("carrier_name")(e.target.value);
                    }}
                  />
                  <TextField
                    label="Unit区分"
                    value={stateForm.unit_class}
                    onChange={(e) => {
                      onChangeText("unit_class")(e.target.value);
                    }}
                  />
                  <TextField
                    label="搬入場所"
                    value={stateForm.delivery_location}
                    onChange={(e) => {
                      onChangeText("delivery_location")(e.target.value);
                    }}
                  />
                  <TextField
                    label="インボイスナンバー"
                    value={stateForm.invoice_no}
                    onChange={(e) => {
                      onChangeText("invoice_no")(e.target.value);
                    }}
                  />
                  <TextField
                    label="シールNo."
                    value={stateForm.seal_no}
                    onChange={(e) => {
                      onChangeText("seal_no")(e.target.value);
                    }}
                  />
                  <TextField
                    label="バース番号"
                    value={stateForm.berth_number}
                    onChange={(e) => {
                      onChangeText("berth_number")(e.target.value);
                    }}
                  />
                  <InputLabel>封印</InputLabel>
                  <ButtonGroup sx={{ ml: 1 }}>
                    <Button
                      variant={stateForm.sealed ? "contained" : "outlined"}
                      onClick={() => {
                        onChangeBoolean("sealed", true);
                      }}
                    >
                      有
                    </Button>
                    <Button
                      variant={
                        stateForm.sealed === false ? "contained" : "outlined"
                      }
                      onClick={() => {
                        onChangeBoolean("sealed", false);
                      }}
                    >
                      無
                    </Button>
                  </ButtonGroup>
                  <TextField
                    label="商品分類"
                    value={stateForm.product_class}
                    onChange={(e) => {
                      onChangeText("product_class")(e.target.value);
                    }}
                  />
                  <TextField
                    label="機種名"
                    value={stateForm.model_name}
                    onChange={(e) => {
                      onChangeText("model_name")(e.target.value);
                    }}
                  />
                  <FormControl>
                    <InputLabel>不適合内容</InputLabel>
                    <StackChip>
                      {renderMultiSelect("defective_products")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect("defective_products", defectList)
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>

                  <TextField
                    label="作業者名"
                    value={stateForm.person_worker}
                    onChange={(e) => {
                      onChangeText("person_worker")(e.target.value);
                    }}
                  />
                  <FormControl>
                    <InputLabel>コンテナの状態</InputLabel>
                    <StackChip>
                      {renderMultiSelect("container_status")}
                      <Button
                        size="small"
                        onClick={() =>
                          handleClickSelect(
                            "container_status",
                            listContainerStatus,
                          )
                        }
                      >
                        追加
                      </Button>
                    </StackChip>
                  </FormControl>
                </Stack>
              </Collapse>
            </div>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Box justifyContent={"center"} display={"flex"} width="100%">
          <Button sx={{ mr: 1 }} onClick={handleClear}>
            クリア
          </Button>
          <Button
            onClick={() => {
              onSearch(stateForm);
              onClose();
            }}
            sx={{ mr: 1 }}
            color="secondary"
            disabled={disabledSubmit}
          >
            検索
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

const styles = {
  dialogHeader: {
    bgcolor: Colors.MAIN_GREEN,
    py: 1,
    px: 2,
    display: "flex",
    alignItems: "center",
    borderRadius: 1,
  },
} as const;

export default SearchDialog;
